import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "game-options" }
const _hoisted_2 = { class: "mr-1 d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "mr-1 d-flex hidden-roles-indicator"
}
const _hoisted_4 = { class: "hidden-roles-text" }
const _hoisted_5 = {
  key: 0,
  class: "mr-1 d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleRoles, (role) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_PreviewLink, {
            target: role,
            linked: _ctx.linked,
            text: ""
          }, null, 8, ["target", "linked"])
        ])
      ]))
    }), 256)),
    (_ctx.hiddenRolesCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, "+" + _toDisplayString(_ctx.hiddenRolesCount), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addons, (amount, addon) => {
      return (_openBlock(), _createElementBlock("div", null, [
        amount
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_PreviewLink, {
                target: addon,
                linked: _ctx.linked,
                text: ""
              }, null, 8, ["target", "linked"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ]))
}